import sdl from '@jds/react-generated-sdl/JDSAvatarV2Notification';
import type { JDSAvatarV2NotificationProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSAvatarV2NotificationProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'dot',
    size = 'medium',
    disabled = false,
    ariaLabel = 'Avatar with Active Notifications',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { kind, size, disabled, ariaLabel, ...rest },
    'JDSAvatarV2Notification',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const AvatarV2Notification = withLogic(
  Component
) as React.FC<JDSAvatarV2NotificationProps> & { slotName?: string };

AvatarV2Notification.displayName = 'AvatarV2Notification';
AvatarV2Notification.slotName = 'jds_avatar_v_2_notification';

export { AvatarV2Notification, type JDSAvatarV2NotificationProps };
